<template>
  <!-- Card lado direito -->
  <div class="col d-none d-md-flex">
    <PasswordConfirmationActivationModal
      @getProgram="$emit('updateProgram')"
      :actionType="actionType"
      :statusProgram="status"
    />
    <section>
      <div class="card mb-3">
        <div class="card-header card-chart-medium d-flex align-items-center">
          <span v-text="$ml.get('status')">Status</span>
        </div>
        <div
          class="card-body card-chart-body pb-0 pt-1 d-flex flex-column justify-content-left"
        >
          <div class="col">
            <div :class="['col mt-2 d-flex justify-content-between', { 'mb-2': status === 'pending' }]"
            >
              <div class="d-flex align-items-center">
                <label style="width:130px" v-text="$ml.get('archiveProgram')" class="mr-2"
                  >Arquivar programa
                </label>
                <VueCustomTooltip :label="$ml.get('archivedProgramTooltip')" :multiline="true" size="is-medium">
                  <svg width="16" height="16" class="mb-1">
                    <image
                      xlink:href="../../src/assets/svg/info-fill.svg"
                      width="16"
                      height="16"
                    />
                  </svg>
                </VueCustomTooltip>
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  v-b-modal.modal-email-authentication
                  @click.prevent="actionType = 'archivedProgram'"
                  :checked="archived"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <hr v-if="status != 'pending'" />
            <div v-if="status != 'pending'" class="col mt-2 mb-2 d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <label style="width:130px" class="mr-2" v-text="$ml.get('pauseProgram')"> Pausar programa </label>
                <VueCustomTooltip :label="$ml.get('pauseProgramTooltip')" :multiline="true" size="is-medium">
                    <svg width="16" height="16" class="mb-1">
                      <image
                        xlink:href="../../src/assets/svg/info-fill.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                </VueCustomTooltip>
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  :disabled="archived"
                  @click.prevent="stopProgram()"
                  :checked="paused"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import ProgramService from "../services/program.service";
import PasswordConfirmationActivationModal from "./modais/PasswordConfirmationActivationModal.vue";

export default {
  name: "CardProgramDetails",
  props: ["status"],
  components: {
    PasswordConfirmationActivationModal,
  },
  data() {
    return {
      actionType: "",
      id: "",
    };
  },
  computed: {
    archived() {
      return this.status === "archived" ? true : false;
    },
    paused() {
      return this.status === "paused" ? true : this.status === "archived" ? true : false;
    },
  },
  created() {
    this.id = this.$route.fullPath.split("?")[1];
  },
  methods: {
    stopProgram() {
      let self = this;
      Swal.fire({
        title: self.status === 'in_progress'
          ? self.$ml.get("doYouWantToPauseTheProgram")
          : self.$ml.get("doYouWantToActivateTheProgram"),
        text: self.status === 'in_progress'
          ? self.$ml.get("byPausingTheProgramExpertsWill")
          : self.$ml.get("byActivatingTheProgramSpecialistsWill"),
        confirmButtonText: self.status === 'in_progress'
          ? self.$ml.get("pause")
          : self.$ml.get("activate"),
        cancelButtonText: self.$ml.get("cancel"),
        customClass: {
          cancelButtonText: "btn-outline-extra",
        },
        showCancelButton: true,
      }).then(function (resp) {
        if (resp.isConfirmed) {
          ProgramService.putProgramStop(self.id)
            .then(() => {
              Swal.fire({
                icon: "success",
                title: self.$ml.get("statusChanged"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
            self.$emit('updateProgram');
            })
            .catch((error) => {
              if(error.response.data.message === 'Antes de reativar o programa, informe ao menos um objetivo!'){
                Swal.fire({
                icon: "warning",
                title: self.$ml.get("defineAtLeastOneGoalBeforeReactivating"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              return;
              }
              const splitMessage = error.response?.data.message.split("_");
              const errorType =
                splitMessage[1] + splitMessage[2] + splitMessage[3];

              if (errorType === "programlimitexceeded") {
                const programType = splitMessage[0];
                Swal.fire({
                  icon: "info",
                  title: "",
                  text: self.$ml
                    .with(
                      "programType",
                      programType === "vdp" ? "VDP" : self.$ml.get(programType),
                    )
                    .get("typeProgramLimitExceeded"),
                });
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped>
label {
  font-size: 15px !important;
}
</style>
